declare global {
  interface Window {
    ym?: (id: number, action: string, goal?: string) => void;
    __YM_ID__?: number;
  }
}

export function reachGoal(goal: 'cta_click' | 'form_submit'): void {
  if (typeof window === 'undefined') return;
  if (typeof window.ym !== 'function') return;
  const id = window.__YM_ID__;
  if (typeof id !== 'number' || !Number.isFinite(id) || id === 0) return;
  window.ym(id, 'reachGoal', goal);
}
